import { render, staticRenderFns } from "./OrangeArrowButton.vue?vue&type=template&id=215b49e0&scoped=true"
import script from "./OrangeArrowButton.vue?vue&type=script&lang=js"
export * from "./OrangeArrowButton.vue?vue&type=script&lang=js"
import style0 from "./OrangeArrowButton.vue?vue&type=style&index=0&id=215b49e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b49e0",
  null
  
)

export default component.exports